import Swiper from 'swiper';
import picturefill from 'picturefill';

/* Load window */
$(function () {
  picturefill();
  // slider on homepage
  var swiper = new Swiper('.swiper-container', {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    loop: true
  });
  // slider on pricelist
  var swiperPriceList = new Swiper('[data-selector="pricelist-swiper"]', {
    slidesPerView: 5,
    spaceBetween: 15,
    simulateTouch: false,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    breakpoints: {
      1219: {
        slidesPerView: 4,
        spaceBetween: 15,
        centeredSlides: true,
        initialSlide: 1,
      },
      959: {
        slidesPerView: 3,
        spaceBetween: 15,
        centeredSlides: true,
        initialSlide: 1,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
        centeredSlides: true,
        initialSlide: 1,
      },
      493: {
        slidesPerView: 1.6,
        spaceBetween: 10,
        centeredSlides: true,
        initialSlide: 1,
      },
      399: {
        slidesPerView: 1.4,
        spaceBetween: 10,
        centeredSlides: true,
        initialSlide: 1,
      },
    }
  });
  if (!window.location.toString().includes("?novejcenik=ano")) {
    // pricelist menu toggle active
    function pricelistMenu() {
      let menu = document.querySelector('[data-selector="pricelist-tarif-menu"]');
      let menuItems = document.querySelectorAll('[data-selector="pricelist-tarif-menu-item"]');
      if (menu && menuItems) {
        menuItems.forEach((item) => {
          if (item.classList.contains('active')) {
            item.addEventListener('touchstart', function () {
              menu.classList.toggle("active");
            });
          }
        });
      }
    }
    pricelistMenu();
  }

  // position of slider buttons for responsive
  if ($(window).width() < 1170) {
    homepageSliderButtonsPosition();
  }

  // reference show more
  $('#reference').click(function (s) {
    var referenceList = $('#reference')
      .parents('.homepage__references--page')
      .find('.homepage-references__item');
    $(referenceList).removeClass('hidden');
    $(this).addClass('hidden');
    s.preventDefault();
    s.stopPropagation();
  });

  // bootstrap tooltip
  $('[data-toggle="tooltip"]').tooltip({
    animation: false
  });
  // stop video after close bootstrap modal
  $('#modal').on('hidden.bs.modal', function (e) {
    var iframe = $(this).find('iframe');

    iframe.attr('src', iframe.attr('src'));
  });

  $('#modal').on('show.bs.modal', function (e) {
    var link = $(e.relatedTarget);
    $(this)
      .find('.modal-dialog')
      .load(link.attr('href'));
  });
});
/* Scroll window */
$(window).scroll(function () {
  var $this = $(this),
    $head = $('header');
  if ($this.scrollTop() > 24) {
    $head.addClass('scrolled');
  } else {
    $head.removeClass('scrolled');
  }
});
/* Resize window */
$(window).resize(function () {
  if ($(window).width() < 1170) {
    homepageSliderButtonsPosition();
  }
});
/* functions */
function homepageSliderButtonsPosition() {
  var height = $('.swiper-slide img').height();
  $('.swiper-button-prev').css({ top: height / 2 + 140 + 'px' });
  $('.swiper-button-next').css({ top: height / 2 + 140 + 'px' });
}

/* Zjištění sticky hlavičky přehledu funkcí */
document.addEventListener('DOMContentLoaded', function() {
    var body = document.body;
    
    if (!body.classList.contains('page-route-features')) {
        return;
    }
    
    var target = document.querySelector('.feature-overview-table__head--main');
    
    if (!target) {
        return;
    }

    var lastScrollTop = Math.round(window.scrollY || document.documentElement.scrollTop);
    var scrolledUpClassAdded = false;
    var currentDirection = null;
    var accumulatedScrollDown = 0;
    var minScrollDelta = 1;
    var directionChangeLock = false;
    var lockDuration = 500;

    window.addEventListener('scroll', function() {
        var scrollTop = Math.round(window.scrollY || document.documentElement.scrollTop);
        var offsetFromViewportTop = target.getBoundingClientRect().top;

        if (offsetFromViewportTop <= 133) {
            if (!target.classList.contains('is-sticky')) {
                target.classList.add('is-sticky');
            }
        } else {
            if (target.classList.contains('is-sticky')) {
                target.classList.remove('is-sticky');
            }
        }

        var scrollDelta = scrollTop - lastScrollTop;

        if (scrollDelta > minScrollDelta) {
            if (currentDirection !== 'down' && !directionChangeLock) {
                currentDirection = 'down';
                if (scrolledUpClassAdded) {
                    accumulatedScrollDown = 0;
                }
                directionChangeLock = true;
                setTimeout(function() {
                    directionChangeLock = false;
                }, lockDuration);
            }

            if (currentDirection === 'down' && scrolledUpClassAdded) {
                accumulatedScrollDown += scrollDelta;
                if (accumulatedScrollDown >= 32) {
                    target.classList.remove('scrolled-up');
                    scrolledUpClassAdded = false;
                    accumulatedScrollDown = 0;
                }
            }
        } else if (scrollDelta < -minScrollDelta) {
            if (currentDirection !== 'up' && !directionChangeLock) {
                currentDirection = 'up';
                if (!scrolledUpClassAdded) {
                    target.classList.add('scrolled-up');
                    scrolledUpClassAdded = true;
                }
                accumulatedScrollDown = 0;
                directionChangeLock = true;
                setTimeout(function() {
                    directionChangeLock = false;
                }, lockDuration);
            }
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
});
